import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";

export default mutatorAction('SET_SCHEDULE_HEADER_ROW_NEEDS_SCROLL_ADJUST', function setScheduleHeaderRowNeedsScrollAdjustment(
    store: SchedulesViewStateStore | IPreviewSchedulePageStore,
    needsAdjustment: boolean
) {
    store.scheduleHeaderRowNeedsScrollAdjustment = needsAdjustment;
});
